import { render, staticRenderFns } from "./DepositTransaction.vue?vue&type=template&id=c2fd344c&"
import script from "./DepositTransaction.vue?vue&type=script&lang=ts&"
export * from "./DepositTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports